import I18n from 'I18n';
import { useCallback, useEffect, useState } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { MoveTicketButton } from '../components/MoveTicketButton';
import { MoveTicketText } from '../components/MoveTicketText';
import { isEligibleForSupport, relocateToSupport } from '../utils/ConversationsRoutingApi';
import { isEligibleForSupport as isEligibleForSupportInternal, relocateToSupport as relocateToSupportInternal } from '../utils/InternalConversationsRoutingApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MoveTicketToSupportCardBody({
  alertStore,
  threadId,
  isPreview = false
}) {
  const [isEligibleForRelocation, setEligibleForRelocation] = useState(false);
  const [eligibilityReason, setEligibilityReason] = useState('SUPPORTED');
  const [isRefreshing, setRefreshing] = useState(false);
  const [isRelocating, setRelocating] = useState(false);
  const updateEligibility = useCallback(() => {
    setRefreshing(true);
    const getEligibility = isPreview ? isEligibleForSupportInternal(threadId) : isEligibleForSupport(threadId);
    getEligibility.then(result => {
      setEligibleForRelocation(result.eligible);
      setEligibilityReason(result.reason);
      setRefreshing(false);
    }).catch(() => setEligibleForRelocation(false));
  }, [isPreview, threadId]);
  const showRelocationError = useCallback(() => {
    if (alertStore) {
      alertStore.addAlert({
        message: I18n.text('app.moveToSupportCard.error.failedToRelocate.body'),
        titleText: I18n.text('app.moveToSupportCard.error.failedToRelocate.title'),
        type: 'danger'
      });
    }
  }, [alertStore]);
  const relocateConversation = useCallback(() => {
    const relocate = isPreview ? relocateToSupportInternal(threadId) : relocateToSupport(threadId);
    setEligibleForRelocation(false);
    setRelocating(true);
    relocate.then(() => {
      setRelocating(false);
      updateEligibility();
    }).catch(() => {
      showRelocationError();
      setRelocating(false);
      updateEligibility();
    });
  }, [isPreview, threadId, showRelocationError, updateEligibility]);
  useEffect(() => {
    updateEligibility();
  }, [updateEligibility]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MoveTicketText, {
      isRefreshing: isRefreshing,
      onRefresh: updateEligibility
    }), /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      direction: "row",
      justify: "center",
      wrap: "wrap",
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(MoveTicketButton, {
        disabledReason: eligibilityReason,
        isDisabled: !isEligibleForRelocation,
        isLoading: isRelocating,
        onClick: relocateConversation
      })
    })]
  });
}